import { useMediaQuery, useTheme } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import MapFiler from 'components/MapFilter';
import { CASABLANCA, FILTERS } from 'components/MapFilter/constants';
import Doctor from 'components/MapFilter/Doctor';
import ItemResult from 'components/MapFilter/ItemResult';
import InfoItem from 'containers/ServicesPage/Info';
import CustomMap from 'containers/ServicesPage/Map';
import {
  GridContainer,
  ScrollableBox,
  StyledDivider,
} from 'containers/ServicesPage/styles';
import { ItemResultProps, Position } from 'containers/ServicesPage/types';
import {
  mapDoctorsToMarkers,
  mapLocationsToItemResults,
  mapLocationsToMarkers,
} from 'containers/ServicesPage/utils';
import { EVENT_CATEGORIES } from 'helpers/GATracking';
import GaClickHOC from 'helpers/GATracking/GaClickHOC';
import useDoctors from 'hooks/doctors/useDoctors';
import React, { useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useSelector } from 'react-redux';
import { getLocationsSelector } from 'store/global/selectors';

const Casablanca: Position = {
  lat: CASABLANCA.lat,
  lng: CASABLANCA.lon,
};

const Body = () => {
  const locations = useSelector(getLocationsSelector);
  const [center, setCenter] = useState(Casablanca);
  const [filter, setFilter] = useState<any>({});
  const [markers, setMarkers] = useState([]);
  const [itemResults, setItemResults] = useState([]);
  const [selected, setSelected] = useState(null);
  const [selectedItem, setSelectedItem] = useState<ItemResultProps | null>(
    null,
  );
  const { data: doctors, get: getDoctors, loadMore, hasMore } = useDoctors();

  const findByIndex = /* istanbul ignore next */ (list: any[], value: number) =>
    list.find((item: any) => item.id === value);

  const filterBy: string = filter.filterWith || FILTERS.allTypes;

  useEffect(() => {
    setMarkers(
      filterBy === FILTERS.doctors
        ? (mapDoctorsToMarkers(doctors) as any)
        : (mapLocationsToMarkers(locations) as any),
    );
    setItemResults(
      filterBy === FILTERS.doctors
        ? doctors
        : (mapLocationsToItemResults(locations) as any),
    );
  }, [locations, doctors]);

  useEffect(() => {
    /* istanbul ignore next */
    if (selected != null) {
      /* istanbul ignore next */
      setSelectedItem(findByIndex(itemResults, selected!) as any);
    } else {
      setSelectedItem(null);
    }
  }, [itemResults, selected]);
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <GridContainer container direction={matches ? 'column' : 'row'}>
      <Grid item xs={matches ? 12 : 5}>
        {selected != null ? (
          <>
            {selectedItem && (
              <InfoItem
                item={selectedItem}
                close={/* istanbul ignore next */ () => setSelected(null)}
              />
            )}
          </>
        ) : (
          <Box pl={matches ? 2 : 4.5} pr={matches ? 2 : 0.5}>
            <MapFiler
              setCenter={setCenter}
              setFilter={setFilter}
              getDoctors={getDoctors}
            />
            {matches && (
              <Grid item xs={12}>
                <CustomMap
                  setSelected={
                    filterBy !== FILTERS.doctors ? setSelected : () => {}
                  }
                  center={center}
                  markers={markers}
                  selected={selected!}
                />
              </Grid>
            )}
            <StyledDivider />
            {filterBy === FILTERS.doctors && (
              <div
                id="scrollableDiv"
                style={{
                  maxHeight: 700,
                  overflow: 'auto',
                }}
              >
                <InfiniteScroll
                  scrollableTarget="scrollableDiv"
                  dataLength={doctors.length}
                  next={/* istanbul ignore next */ () => loadMore(filter)}
                  hasMore={hasMore}
                  loader={null}
                >
                  <ScrollableBox>
                    {itemResults.map((item: any, index: number) => {
                      return (
                        <GaClickHOC
                          category={EVENT_CATEGORIES.SERVICES}
                          label="Détails"
                        >
                          <Doctor key={index} doctor={item} />
                        </GaClickHOC>
                      );
                    })}
                  </ScrollableBox>
                </InfiniteScroll>
              </div>
            )}
            {itemResults.length > 0 && filterBy !== FILTERS.doctors && (
              <ScrollableBox>
                {itemResults.map((item: any, index: number) => {
                  return (
                    <GaClickHOC
                      category={EVENT_CATEGORIES.SERVICES}
                      label="Détails"
                    >
                      <ItemResult
                        key={index}
                        title={item.title}
                        subTitle={item.subTitle}
                        onClick={
                          /* istanbul ignore next */ () =>
                            filterBy !== FILTERS.doctors && setSelected(item.id)
                        }
                      />
                    </GaClickHOC>
                  );
                })}
              </ScrollableBox>
            )}
          </Box>
        )}
      </Grid>
      {!matches && (
        <Grid item xs={matches ? 12 : 7}>
          <CustomMap
            setSelected={filterBy !== FILTERS.doctors ? setSelected : () => {}}
            center={center}
            markers={markers}
            selected={selected!}
          />
        </Grid>
      )}
    </GridContainer>
  );
};

export default Body;
